import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const benefits = [{
  title: 'Dual Expertise',
  description: "We're both buyers and sellers of call traffic. This unique position means we understand both sides of the equation and optimize accordingly."
}, {
  title: 'Quality-First Approach',
  description: 'Rigorous filtering and compliance standards ensure every call meets your criteria. No time-wasters, just qualified consumers.'
}, {
  title: 'Proprietary + Partner Traffic',
  description: 'We generate high-quality calls in-house and maintain a vetted network of top-tier publishers for scalable volume.'
}, {
  title: 'Real-Time Reporting',
  description: 'Track performance with detailed analytics. Full transparency on call duration, disposition, and ROI metrics.'
}, {
  title: 'Compliance & Trust',
  description: 'TCPA-compliant operations with proper consent protocols. We protect your brand and maintain the highest industry standards.'
}, {
  title: 'Proven Performance',
  description: 'Years of experience in online marketing with millions in revenue generated for our partners across various niches.'
}];
export function WhyPartner() {
  return <section className="py-20 px-6 bg-white" data-id="element-75">
      <div className="max-w-7xl mx-auto" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-77">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-78">
            Why Partner With Us?
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-79">
          {benefits.map((benefit, index) => <motion.div key={benefit.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex gap-4" data-id="element-80">
              <div className="flex-shrink-0" data-id="element-81">
                <CheckCircle className="w-6 h-6 text-emerald-600" data-id="element-82" />
              </div>
              <div data-id="element-83">
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-84">
                  {benefit.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-85">
                  {benefit.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}